/**
 * Created by ty 879372858@qq.com on 18/2/1.
 *
 */
import Vue from 'vue';
import Element from 'element-ui';
import VueDraggableResizable from 'vue-draggable-resizable';
import BrowserContainer from './router/defaultRouter.js';
import Test from './views/home/index.vue';
import modelview from './store/index.js';
import VueCookies from 'vue-cookies';
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue();
Vue.component('vue-draggable-resizable', VueDraggableResizable);
Vue.use(Element, {
  size: 'medium'
});
Vue.use(VueCookies);
Vue.config.productionTip = false;
export {
  Test,
  BrowserContainer,
  modelview
};



// WEBPACK FOOTER //
// ./src/index.js